const downloadServers = JSON.parse(require('../../download-servers/download-servers.json').default);

(() => {
  self.performance = self.performance || {
    now: Date.now,
  };

  if (
    navigator.connection
    && navigator.connection.saveData
  ) {
    return;
  }

  const servers = downloadServers.result
    .filter((entry) => entry.active === true || entry.active === 1 || entry.active === '1')
    .map((entry) => entry.host);

  if (!servers.length) {
    return;
  }

  self.addEventListener('message', (e) => {
    const xhr = new XMLHttpRequest();
    const duration = 5000;
    let startTime;
    let server = servers[Math.floor(Math.random() * servers.length)];

    if (e.data && e.data.server) {
      server = e.data.server;
    }

    const testFileUrl = `https://${server}/rand100.data`;

    function calculateSpeedAverage(bytesLoaded) {
      const currentTime = performance.now();
      const duration = currentTime - startTime;
      const seconds = duration / 1000;
      const averageBytesPerSecond = bytesLoaded / seconds;
      const averageMbitPerSecond = Math.round((averageBytesPerSecond * 8) / 1000) / 1000;

      if (self.console) {
        console.log(`${bytesLoaded} bytes loaded from ${server} in ${seconds} seconds.`);
        console.info(`Your measured average speed to ${server} is ${averageMbitPerSecond} MBit/s`);
      }

      self.postMessage({
        action: 'result',
        server,
        speed: averageMbitPerSecond,
      });
    }

    function readyStateChange() {
      if (xhr.readyState !== 3) {
        return;
      }

      if (startTime) {
        return;
      }

      startTime = performance.now();
    }

    function updateProgress(e) {
      const currentTime = performance.now();
      if (
        currentTime - startTime >= duration
        && xhr.readyState !== 4
      ) {
        calculateSpeedAverage(e.loaded);
        xhr.abort();
      }

      const loaded = Math.round((e.loaded / (100 * 1024 * 1024)) * 100) / 100;
      const time = Math.round(((currentTime - startTime) / duration) * 100) / 100;

      self.postMessage({
        action: 'progress',
        server,
        loaded: Math.min(loaded, 1),
        duration: Math.min(time, 1),
      });
    }

    function transferComplete(e) {
      calculateSpeedAverage(e.loaded);
    }

    xhr.addEventListener('readystatechange', readyStateChange);
    xhr.addEventListener('progress', updateProgress);
    xhr.addEventListener('load', transferComplete);

    const xhrUrl = `${testFileUrl}?nocache=${(new Date().getTime())}`;

    xhr.open('GET', xhrUrl);
    xhr.send();
  });
})();



// WEBPACK FOOTER //
// ./src/js/webworkers/speedtest-worker.js